/*
 * @Descripttion:
 * @version: v1
 * @Author: liukx
 * @Date: 2022-04-30 15:36:43
 * @LastEditors: ???
 * @LastEditTime: 2022-05-19 21:11:09
 */
export function timeFormat(fmt) {
  var date = new Date(fmt * 1000); //如果date为13位不需要乘1000
  var Y = date.getFullYear() + '-';
  var M =
    (date.getMonth() + 1 < 10
      ? '0' + (date.getMonth() + 1)
      : date.getMonth() + 1) + '-';
  var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
  var h =
    (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
  var m =
    (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
    ':';
  var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
  return Y + M + D + h + m + s;
}

export function toThousandFilter(num) {
  return (+num || 0).toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
}


// 流程状态
export const healthCode = (val) => {
  switch (val) {
    case 0:
      return '正常';
    case 1:
      return '红码';
    case 2:
      return '黄码';
    case 3:
      return '弹窗';
    default:
      return '';
  }
};

// 用户角色
export const isAdmin = (val) => {
  switch (val) {
    case 0:
      return '普通用户';
    case 1:
      return '管理员';
    default:
      return '';
  }
};

// 房屋状态
export const orderStatus = (val) => {
  switch (val) {
    case 0:
      return '新订单';
    case 1:
      return '进行中';
    case 2:
      return '已完成';
    case 3:
      return '已取消';
    default:
      return '';
  }
};

// 数据状态
export const dataStatus = (val) => {
  if (val == 0) {
    return '有效';
  } else {
    return '无效';
  }
};
// 出入状态
export const accessMode = (val) => {
  switch (val) {
    case 0:
      return '入';
    case 1:
      return '出';

    default:
      return '';
  }
};
// 日期去除时分秒
export const sliceDate = (val) => {
  if (!val) return
      return val.substring(0, 10);
};

